import { ShieldCheck } from "lucide-react";
import type { OrganizationDetail } from "../../account";

type OrganizationReviewStepProps = {
  claimCount: number;
  data: OrganizationDetail;
};

export function OrganizationReviewStep({
  claimCount,
  data,
}: OrganizationReviewStepProps) {
  return (
          <fieldset className="wide-field application-review">
            <legend>5. Tarkista ja lähetä</legend>
            <div>
              <section>
                <b>Hakemuksen yhteenveto</b>
                <dl>
                  <div>
                    <dt>Organisaatio</dt>
                    <dd>{data.organization.name}</dd>
                  </div>
                  <div>
                    <dt>Y-tunnus</dt>
                    <dd>{data.organization.business_id ?? "Ei ilmoitettu"}</dd>
                  </div>
                  <div>
                    <dt>Palvelut</dt>
                    <dd>Valintojen mukaan</dd>
                  </div>
                  <div>
                    <dt>Alueet</dt>
                    <dd>{claimCount} aluetta</dd>
                  </div>
                </dl>
              </section>
              <label>
                <ShieldCheck />
                <span>
                  <b>Vakuutus ja hyväksyntä</b>
                  <small>
                    Vakuutan antamani tiedot oikeiksi ja hyväksyn palvelun
                    käyttöehdot.
                  </small>
                </span>
                <input type="checkbox" required />
              </label>
            </div>
          </fieldset>
  );
}

